import logo from "../../../assets/logo_cut.png";
import { Center, Image, Text, VStack } from "native-base";

type Props = {};

export function PoliticaTermos({}: Props) {
  return (
    <VStack space={4} alignItems="flex-start" bgColor="white" p={4} h={"100%"}>
      {/* Políticas de privacidade */}
      <>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          Política Privacidade
        </Text>
        <Text>
          <Text>
            A sua privacidade é importante para nós. É política do Mama Lei
            respeitar a sua privacidade em relação a qualquer informação sua que
            possamos coletar no site{" "}
            <a href="https://mama-lei.netlify.app/">Mama Lei</a>, e outros sites
            que possuímos e operamos.
          </Text>
        </Text>
        <Text>
          <Text>
            Solicitamos informações pessoais apenas quando realmente precisamos
            delas para lhe fornecer um serviço. Fazemo-lo por meios justos e
            legais, com o seu conhecimento e consentimento. Também informamos
            por que estamos coletando e como será usado.
          </Text>
        </Text>
        <Text>
          <Text>
            Apenas retemos as informações coletadas pelo tempo necessário para
            fornecer o serviço solicitado. Quando armazenamos dados, protegemos
            dentro de meios comercialmente aceitáveis ​​para evitar perdas e
            roubos, bem como acesso, divulgação, cópia, uso ou modificação não
            autorizados.
          </Text>
        </Text>
        <Text>
          <Text>
            Não compartilhamos informações de identificação pessoal publicamente
            ou com terceiros, exceto quando exigido por lei.
          </Text>
        </Text>
        <Text>
          <Text>
            O nosso site pode ter links para sites externos que não são operados
            por nós. Esteja ciente de que não temos controle sobre o conteúdo e
            práticas desses sites e não podemos aceitar responsabilidade por
            suas respectivas&nbsp;
          </Text>
          <a
            href="https://politicaprivacidade.com/"
            rel="noopener noreferrer"
            target="_blank"
          >
            políticas de privacidade
          </a>
          <Text>.</Text>
        </Text>
        <Text>
          <Text>
            Você é livre para recusar a nossa solicitação de informações
            pessoais, entendendo que talvez não possamos fornecer alguns dos
            serviços desejados.
          </Text>
        </Text>
        <Text>
          <Text>
            O uso continuado de nosso site será considerado como aceitação de
            nossas práticas em torno de privacidade e informações pessoais. Se
            você tiver alguma dúvida sobre como lidamos com dados do usuário e
            informações pessoais, entre em contacto connosco.
          </Text>
        </Text>
        <Text>
          <Text></Text>
        </Text>
        <Text>
          <Text>Compromisso do Usuário</Text>
        </Text>
        <Text>
          <Text>
            O usuário se compromete a fazer uso adequado dos conteúdos e da
            informação que o Mama Lei oferece no site e com caráter enunciativo,
            mas não limitativo:
          </Text>
        </Text>
        <ul>
          <li>
            <Text>
              A) Não se envolver em atividades que sejam ilegais ou contrárias à
              boa fé a à ordem pública;
            </Text>
          </li>
          <li>
            <Text>
              B) Não difundir propaganda ou conteúdo de natureza racista,
              xenofóbica,{" "}
            </Text>
            <Text>
              <a href="https://apostasonline.guru/betano-apostas/">betano</a>
            </Text>
            <Text>
              {" "}
              ou azar, qualquer tipo de pornografia ilegal, de apologia ao
              terrorismo ou contra os direitos humanos;
            </Text>
          </li>
          <li>
            <Text>
              C) Não causar danos aos sistemas físicos (hardwares) e lógicos
              (softwares) do Mama Lei, de seus fornecedores ou terceiros, para
              introduzir ou disseminar vírus informáticos ou quaisquer outros
              sistemas de hardware ou software que sejam capazes de causar danos
              anteriormente mencionados.
            </Text>
          </li>
        </ul>
        <Text>
          <Text>Mais informações</Text>
        </Text>
        <Text>
          <Text>
            Esperemos que esteja esclarecido e, como mencionado anteriormente,
            se houver algo que você não tem certeza se precisa ou não,
            geralmente é mais seguro deixar os cookies ativados, caso interaja
            com um dos recursos que você usa em nosso site.
          </Text>
        </Text>
        <Text>
          <Text>
            Esta política é efetiva a partir de&nbsp;24 May 2023 22:59
          </Text>
        </Text>
      </>

      {/* Termos de serviço */}
      <>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          <span>1. Termos</span>
        </Text>
        <p>
          <span>
            Ao acessar ao site{" "}
            <a href="https://mama-lei.netlify.app/">Mama Lei</a>, concorda em
            cumprir estes termos de serviço, todas as leis e regulamentos
            aplicáveis ​​e concorda que é responsável pelo cumprimento de todas
            as leis locais aplicáveis. Se você não concordar com algum desses
            termos, está proibido de usar ou acessar este site. Os materiais
            contidos neste site são protegidos pelas leis de direitos autorais e
            marcas comerciais aplicáveis.
          </span>
        </p>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          <span>2. Uso de Licença</span>
        </Text>
        <p>
          <span>
            É concedida permissão para baixar temporariamente uma cópia dos
            materiais (informações ou software) no site Mama Lei , apenas para
            visualização transitória pessoal e não comercial. Esta é a concessão
            de uma licença, não uma transferência de título e, sob esta licença,
            você não pode:&nbsp;
          </span>
        </p>
        <ol>
          <li>
            <span>modificar ou copiar os materiais;&nbsp;</span>
          </li>
          <li>
            <span>
              usar os materiais para qualquer finalidade comercial ou para
              exibição pública (comercial ou não comercial);&nbsp;
            </span>
          </li>
          <li>
            <span>
              tentar descompilar ou fazer engenharia reversa de qualquer
              software contido no site Mama Lei;&nbsp;
            </span>
          </li>
          <li>
            <span>
              remover quaisquer direitos autorais ou outras notações de
              propriedade dos materiais; ou&nbsp;
            </span>
          </li>
          <li>
            <span>
              transferir os materiais para outra pessoa ou 'espelhe' os
              materiais em qualquer outro servidor.
            </span>
          </li>
        </ol>
        <p>
          <span>
            Esta licença será automaticamente rescindida se você violar alguma
            dessas restrições e poderá ser rescindida por Mama Lei a qualquer
            momento. Ao encerrar a visualização desses materiais ou após o
            término desta licença, você deve apagar todos os materiais baixados
            em sua posse, seja em formato eletrónico ou impresso.
          </span>
        </p>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          <span>3. Isenção de responsabilidade</span>
        </Text>
        <ol>
          <li>
            <span>
              Os materiais no site da Mama Lei são fornecidos 'como estão'. Mama
              Lei não oferece garantias, expressas ou implícitas, e, por este
              meio, isenta e nega todas as outras garantias, incluindo, sem
              limitação, garantias implícitas ou condições de comercialização,
              adequação a um fim específico ou não violação de propriedade
              intelectual ou outra violação de direitos.
            </span>
          </li>
          <li>
            <span>
              Além disso, o Mama Lei não garante ou faz qualquer representação
              relativa à precisão, aos resultados prováveis ​​ou à
              confiabilidade do uso dos materiais em seu site ou de outra forma
              relacionado a esses materiais ou em sites vinculados a este site.
            </span>
          </li>
        </ol>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          <span>4. Limitações</span>
        </Text>
        <p>
          <span>
            Em nenhum caso o Mama Lei ou seus fornecedores serão responsáveis
            ​​por quaisquer danos (incluindo, sem limitação, danos por perda de
            dados ou lucro ou devido a interrupção dos negócios) decorrentes do
            uso ou da incapacidade de usar os materiais em Mama Lei, mesmo que
            Mama Lei ou um representante autorizado da Mama Lei tenha sido
            notificado oralmente ou por escrito da possibilidade de tais danos.
            Como algumas jurisdições não permitem limitações em garantias
            implícitas, ou limitações de responsabilidade por danos conseqüentes
            ou incidentais, essas limitações podem não se aplicar a você.
          </span>
        </p>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          <span>5. Precisão dos materiais</span>
        </Text>
        <p>
          <span>
            Os materiais exibidos no site da Mama Lei podem incluir erros
            técnicos, tipográficos ou fotográficos. Mama Lei não garante que
            qualquer material em seu site seja preciso, completo ou atual. Mama
            Lei pode fazer alterações nos materiais contidos em seu site a
            qualquer momento, sem aviso prévio. No entanto, Mama Lei não se
            compromete a atualizar os materiais.
          </span>
        </p>
        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          <span>6. Links</span>
        </Text>
        <p>
          <span>
            O Mama Lei não analisou todos os sites vinculados ao seu site e não
            é responsável pelo conteúdo de nenhum site vinculado. A inclusão de
            qualquer link não implica endosso por Mama Lei do site. O uso de
            qualquer site vinculado é por conta e risco do usuário.
          </span>
        </p>
        <p></p>
        <h3>
          <span>Modificações</span>
        </h3>
        <p>
          <span>
            O Mama Lei pode revisar estes termos de serviço do site a qualquer
            momento, sem aviso prévio. Ao usar este site, você concorda em ficar
            vinculado à versão atual desses termos de serviço.
          </span>
        </p>
        <h3>
          <span>Lei aplicável</span>
        </h3>
        <p>
          <span>
            Estes termos e condições são regidos e interpretados de acordo com
            as leis do Mama Lei e você se submete irrevogavelmente à jurisdição
            exclusiva dos tribunais naquele estado ou localidade.
          </span>
        </p>
      </>
    </VStack>
  );
}
